import { makeStyles } from "@material-ui/core"

const styles = makeStyles((theme) => ({
  dialogPaper: {
    maxWidth: 855,
  },
  dialogPaperLocked: {
    maxWidth: 500,
  },
  dialogContent: {
    display: "flex",
    padding: theme.spacing(2.25),
    paddingRight: theme.spacing(1.25),
    overflow: "hidden",
    fontFamily: ["Roboto", "sans-serif"],
    [theme.breakpoints.down("sm")]: {
      flexWrap: "wrap",
      overflow: "scroll",
    },
  },
  assessmentType: {
    marginLeft: theme.spacing(2),
    marginRight: theme.spacing(2),
    display: "flex",
    alignItems: "center",
    flexDirection: "column",
    maxWidth: "100px",
    [theme.breakpoints.down("sm")]: {
      marginRight: "auto",
      textAlign: "center",
      marginBottom: "5px",
      display: "flex",
      alignItems: "center",
      flexDirection: "column",
    },
  },

  questionsNumber: {
    marginLeft: theme.spacing(2),
    marginRight: theme.spacing(2),
    display: "flex",
    alignItems: "center",
    flexDirection: "column",
    maxWidth: "100px",

    [theme.breakpoints.down("sm")]: {
      marginRight: "auto",
      textAlign: "center",
      marginBottom: "5px",
      display: "flex",
      alignItems: "center",
      flexDirection: "column",
    },
  },
  minPassScore: {
    marginLeft: theme.spacing(2),
    marginRight: theme.spacing(2),
    display: "flex",
    alignItems: "center",
    flexDirection: "column",
    maxWidth: "100px",

    [theme.breakpoints.down("sm")]: {
      marginRight: "auto",
      textAlign: "center",
      marginBottom: "5px",
      display: "flex",
      alignItems: "center",
      flexDirection: "column",
    },
  },
  inputLabel: {
    marginBottom: theme.spacing(1),
  },
  actionBox: {
    [theme.breakpoints.down("sm")]: {
      width: 300,
      margin: 0,
    },
  },
  container: {
    padding: theme.spacing(1),
    width: "100%",
    alignItems: "center",
    [theme.breakpoints.down("sm")]: {
      marginLeft: "auto",
      marginRight: "auto",
      marginTop: theme.spacing(2),
    },
  },
  requiredText: {
    color: theme.palette.warning.main,
    marginTop: theme.spacing(1),
  },
  root: {
    color: "red",
  },
  dialogTitle: {
    display: "flex",
    alignItems: "flex-end",
    [theme.breakpoints.down("sm")]: {
      //flexDirection: "column",
      alignItems: "inherit",
    },
  },
  dialogItems: {
    display: "flex",
    alignItems: "flex-end",
    justifyContent: "center",
    marginTop: "20px",
    width: "500px",
    [theme.breakpoints.down("sm")]: {
      alignItems: "flex-end",
    },
  },
}))

export default styles
